export default __webpack_public_path__ + "static/SCROLL_2-0f62b64bb4a2cb340bf8bfa733e9dcb8.png";